import { render, staticRenderFns } from "./SideMenuLinkList.vue?vue&type=template&id=4642be06&scoped=true"
import script from "./SideMenuLinkList.vue?vue&type=script&lang=ts"
export * from "./SideMenuLinkList.vue?vue&type=script&lang=ts"
import style0 from "./SideMenuLinkList.vue?vue&type=style&index=0&id=4642be06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4642be06",
  null
  
)

export default component.exports